export default "__VITE_ASSET__BuSI4iq8__"